export default {"src":"__ASTRO_ASSET_IMAGE__HM8P7f2I__","width":232,"height":57,"format":"svg"}